import { render } from "./consultation.vue?vue&type=template&id=7c3f18f4&scoped=true"
import script from "./consultation.vue?vue&type=script&lang=js"
export * from "./consultation.vue?vue&type=script&lang=js"

import "./consultation.vue?vue&type=style&index=0&id=7c3f18f4&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3f18f4"]])

export default __exports__